import { useContext } from 'react';
import { SuperAdminContext } from 'src/components';

export const useSuperAdminApiOverrides = () => {
  const { org } = useContext(SuperAdminContext);
  if (!org?.org_uuid) {
    return {};
  }

  return {
    headers: {
      'Impersonate-Org-UUID': `${org?.org_uuid}`,
      'Headless-Mode': true,
    },
  };
};
